import React from 'react'

import styles from './TeacherDivisor.module.css'

const TeacherDivisor = () => (
  <div className={styles.teacher}>
    <span className={styles.text}>
      <img className={styles.image} src='/assets/images/icon-teacher.svg' alt='Plurall Professor' />
      Professor
    </span>
    <hr className={styles.rounded} />
  </div>
)

export default TeacherDivisor
